import NewListingForm from "../../components/admin/NewListingForm"


export default function NewListingPage(){
  return (
   <NewListingForm />
  )
}
